import { render } from "./FirstStep.vue?vue&type=template&id=f9c4171e"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"

import "./FirstStep.vue?vue&type=style&index=0&id=f9c4171e&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__